<div class="table-container">
    <div><ng-content select="table-container-top"></ng-content></div>
    <div *ngIf="showTable"><ng-content></ng-content></div>
    <div class="no-result-message-container" *ngIf="shownNoResultMessage()">
        <p class="font-weight-300 text-grey table-spinner">{{ noResultMessage }}</p>
    </div>
    <div class="clearfix table-container-paginate">
        <div *ngIf="showProgress" class="table-spinner">
            <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
        </div>
        <table-page-size
                *ngIf="onPerPageChange.observers.length > 0"
                [style.display]="disablePagination ? 'none' : 'block'"
                [totalItems]="collection.total || 0"
                [pageSize]="getPageSize().toString()"
                [pageSizes]="pageSizes"
                (onPerPageChange)="pageSizeChange($event)"
                class="pull-left">
        </table-page-size>

        <div class="pull-right"
             *ngIf="onPageChange.observers.length > 0"
             [style.display]="disablePagination ? 'none' : 'block'">
            <ngb-pagination
                [collectionSize]="collection.total || 0"
                [(page)]="collection.currentPage!"
                (pageChange)="pageChange()"
                class="table-pagination"
                [pageSize]="getPageSize()"
                [rotate]="true"
                [maxSize]="7"
                [ellipses]="true"
                [boundaryLinks]="false"
                *ngIf="showPagination()">
            </ngb-pagination>
        </div>
    </div>
</div>
